import { useDialogStore, DialogConfig } from '../../stores/dialogStore';
import ConfirmDialog from './ConfirmDialog';
import FormDialog from './FormDialog';
import InfoDialog from './InfoDialog';
import SuccessDialog from './SuccessDialog';
import LoadingDialog from './LoadingDialog';

export default function DialogProvider() {
  const { dialogs, closeDialog } = useDialogStore();

  return (
    <>
      {Array.from(dialogs.values()).map((config: DialogConfig) => {
        const handleClose = () => closeDialog(config.id);

        switch (config.type) {
          case 'confirm':
            return (
              <ConfirmDialog
                key={config.id}
                config={config}
                onClose={handleClose}
              />
            );
          case 'form':
            return (
              <FormDialog
                key={config.id}
                config={config}
                onClose={handleClose}
              />
            );
          case 'info':
            return (
              <InfoDialog
                key={config.id}
                config={config}
                onClose={handleClose}
              />
            );
          case 'success':
            return (
              <SuccessDialog
                key={config.id}
                config={config}
                onClose={handleClose}
              />
            );
          case 'loading':
            return <LoadingDialog key={config.id} config={config} />;
          default:
            return null;
        }
      })}
    </>
  );
}
